/* global axios */
import ApiClient from './ApiClient';

class AgentBotsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  getAllData() {
    return axios.get(this.url, {
      params: { all_data: true },
    });
  }

  getSimpleData() {
    return axios.get(this.url, {
      params: { simple_data: true },
    });
  }

  create(data) {
    return axios.post(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteAgentBotAvatar(botId) {
    return axios.delete(`${this.url}/${botId}/avatar`);
  }

  resetAccessToken(botId) {
    return axios.post(`${this.url}/${botId}/reset_access_token`);
  }

  resetSecret(botId) {
    return axios.post(`${this.url}/${botId}/reset_secret`);
  }

  csmlEditorUrl() {
    return axios.get(`${this.url}/csml_editor_url`);
  }

  n8nWorkflowUrl(botId) {
    return axios.get(`${this.url}/${botId}/n8n_workflow_url`);
  }
}

export default new AgentBotsAPI();
